import { httpCreate } from './http';

const http = httpCreate('/shop/api/phy-store');

export const phyStore = {
	getStoreList(params) {
		return http.get('/page', { params });
	},
};
